module.exports = __webpack_public_path__ + "img/27.efeef4c1.png";